//
//
//Function:test_table
//
//
//To display test table details,
//
//get bench details,
//
//
//send data to bench,
//
//
//pull data from bench,
//
//edit and delete test table
//
//
import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap'
import { connect } from 'react-redux'
import { getTestDataBenchMappingInfo } from '../components/UserFunctions'
import { sendToBench } from './UserFunctions'
import { pullFromBench } from './UserFunctions'
import { cleanBenchInputOutput, startBenchProcess, stopBenchProcess } from './UserFunctions'
import { updateBenchStatusTable, createBenchData } from './UserFunctions'
import PopupModal from './PopupModal.js'
import TagNamePopUpModal from './TagNamePopupModal.js'
import PropTypes from 'prop-types';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import EditTestTableModal from "./EditTestTableModal"
import { addTestTableFromAPI } from "../actions/scenarioTestTableAction"
import DeleteTestTableModal from "./DeleteTestTableModal"

import { addTestPoint, getBenchDetails, getAllScenarioGroupNames } from './UserFunctions'
import { Link } from 'react-router-dom'


class UploadFile extends Component {
    constructor() {
        super()
        //
        // Function for initializing default values
        //
        this.state = {
            data: [],
            showpopup: false,
            statusPopup: "",
            toggleButton: false,
            tagName: false,
            index: 0,
            tageNameVersion: "",
            remarks: "",
            test_run_id: "",
            editSelectedRow: undefined,
            showRowActions: undefined,
            deleteSelectedRow: undefined,
            testPoint: false,
            scenario_group_name: "",
            bench_details: [],
            group_name_list: [],
            selected_bench_name: "",
            selected_bench_id: "",
            // showpopup : false,
            status: ""
        }
        //
        //Functions
        //
        //this.handleUploadButton = this.handleUploadButton.bind(this)
        this.cleanBenchProcess = this.cleanBenchProcess.bind(this)
        this.startBench = this.startBench.bind(this)
        this.stopBench = this.stopBench.bind(this)
        this.togglePopup = this.togglePopup.bind(this)
        this.toggleTagName = this.toggleTagName.bind(this)
        this.handleTagNameVersionChange = this.handleTagNameVersionChange.bind(this)
        this.handleRemarksChange = this.handleRemarksChange.bind(this)
        this.sendToBenchAPI = this.sendToBenchAPI.bind(this)
        this.pullFromBenchAPI = this.pullFromBenchAPI.bind(this)
        this.closeTagNameModal = this.closeTagNameModal.bind(this)

        this.handleOpenEditModal = this.handleOpenEditModal.bind(this);
        this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
        this.handleOpenDialogModal = this.handleOpenDialogModal.bind(this);
        this.handleCloseDialogModal = this.handleCloseDialogModal.bind(this);
        this.handleOpenDeleteModal = this.handleOpenDeleteModal.bind(this);
        this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this);

        this.handleOpenTestPoint = this.handleOpenTestPoint.bind(this);
        this.handleCloseTestPoint = this.handleCloseTestPoint.bind(this);
        this.handleTestPointSubmit = this.handleTestPointSubmit.bind(this);

        this.onhandleChangeGroupName = this.onhandleChangeGroupName.bind(this);
        this.onhandleChangeBenchName = this.onhandleChangeBenchName.bind(this);
        this.handleAdd = this.handleAdd.bind(this);

        this.startBenchFunction = this.startBenchFunction.bind(this)

        // this.cleanBenchProcess = this.cleanBenchProcess.bind(this)
        // this.startBench = this.startBench.bind(this)
        // this.stopBench = this.stopBench.bind(this)
        // this.togglePopup = this.togglePopup.bind(this)
        // this.toggleTagName = this.toggleTagName.bind(this)
        // this.handleTagNameVersionChange = this.handleTagNameVersionChange.bind(this)
        // this.handleRemarksChange = this.handleRemarksChange.bind(this)
        // this.sendToBenchAPI = this.sendToBenchAPI.bind(this)
        // this.pullFromBenchAPI = this.pullFromBenchAPI.bind(this)
        // this.closeTagNameModal = this.closeTagNameModal.bind(this)

        // this.handleOpenEditModal = this.handleOpenEditModal.bind(this);
        // this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
        // this.handleOpenDialogModal = this.handleOpenDialogModal.bind(this);
        // this.handleCloseDialogModal = this.handleCloseDialogModal.bind(this);
        // this.handleOpenDeleteModal = this.handleOpenDeleteModal.bind(this);
        // this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this);

        // this.handleOpenTestPoint = this.handleOpenTestPoint.bind(this);
        // this.handleCloseTestPoint = this.handleCloseTestPoint.bind(this);
        // this.handleTestPointSubmit = this.handleTestPointSubmit.bind(this);

        // this.onhandleChangeGroupName = this.onhandleChangeGroupName.bind(this);
        // this.onhandleChangeBenchName = this.onhandleChangeBenchName.bind(this);
        // this.handleAdd = this.handleAdd.bind(this);

    }
    //
    // Function to change the bench name
    //
    onhandleChangeBenchName(e) {
        this.setState({
            selected_bench_name: e.target.value
        })

        this.state.bench_details.forEach((index) => {
            if (index['bench_name'] === e.target.value) {
                this.setState({
                    selected_bench_id: index['bench_id']
                })
            }
        })
    }
    //
    // Function to change the group name
    //
    onhandleChangeGroupName(e) {
        this.setState({
            scenario_group_name: e.target.value
        })
    }
    //
    // Function to add scenario
    //
    handleAdd(e) {
        e.preventDefault();
        console.log("ScenarioGroupName : ", this.state.scenario_group_name)
        console.log("Bench Id : ", this.state.bench_id)

        const goto_url = (window.location.origin).concat('/add_test_point')
        const payload = {
            scenario_group_name: this.state.scenario_group_name,
            bench_id: parseInt(this.state.selected_bench_id)
        }
        //
        // Function to add test point
        //
        addTestPoint(payload, goto_url).then(res => {
            console.log("response after addition : ", res['data']['status_message'])
            console.log("state of showpopup : ", this.state.showpopup)
            this.setState({
                statusPopup: res['data']['status_message'],
                showpopup: !this.state.showpopup,
                testPoint: false,
            })
        })

    }
    //
    // Function to close tagname popup
    //
    closeTagNameModal() {
        this.setState({
            tagName: false
        })
    }
    //
    // Function to handle tagname version change
    //
    handleTagNameVersionChange(tagName) {
        this.setState({
            tageNameVersion: tagName
        })
    }
    //
    // Function to handle remarks change
    //
    handleRemarksChange(remark) {
        this.setState({
            remarks: remark
        })

    }
    //
    // Function fo toggle popup
    //
    togglePopup() {
        this.setState({
            showpopup: !this.state.showpopup,
            statusPopup: "",
            testPoint: false,
        })
        const current = window.location.pathname;
        this.props.history.replace(`/`);
        setTimeout(() => {
            this.props.history.replace(current);
        });
    }
    //
    // Function to toggle tag name
    //
    toggleTagName(e) {
        console.log('im into toggleTagName')
        console.log(e.target.id)
        const buttonValue = e.target.innerHTML;
        //const index_value = index_val['index']
        console.log('Button value : ', buttonValue)
        //const indexValue = e.target.value;
        if (buttonValue === "Push") {
            this.setState({
                tagName: !this.state.tagName,
                index: e.target.id
            })
        }
        else {
            //call pull from bench api
            this.setState({
                index: e.target.id
            })
            this.pullFromBenchAPI(e.target.id)
        }

    }
    //
    // Function to send data to bench
    //
    sendToBenchAPI() {
        this.setState({
            tagName: false
        })
        const origin = window.location.origin
        const go_to_url = origin.concat("/send-scenario-to-bench")
        const index = this.state.index
        console.log("INdex for send : ", index)
        const data_to_send = {
            bench_id: this.state.data[index]['bench_id'],
            scenario_group_id: this.state.data[index]['scenario_group_id']
        }
        sendToBench(data_to_send, go_to_url).then(res => {
            //console.log("response after pushing data to bench :  ", res['data']['status'])
            if (res['data']['status'] === "send_successfully") {
                getTestDataBenchMappingInfo().then(res => {
                    console.log(res)
                    this.setState(prevState => {
                        return {
                            ...prevState,
                            data: res.data.map((item, itemIndex) => {
                                console.log(item)
                                if (itemIndex === parseInt(index, 10)) {
                                    return {
                                        test_point_id: item.test_point_id,
                                        bench_id: item.bench_id,
                                        bench_name: item.bench_name,
                                        scenario_group_id: item.scenario_group_id,
                                        scenario_group_name: item.scenario_group_name,
                                        status: item.status,
                                        upload_button: !item.upload_button
                                    }
                                } else {
                                    return item
                                }
                            })
                        }
                    })
                })

            }
            //
            // Function for set state
            //
            this.setState({
                statusPopup: res['data']['status_message'],
                showpopup: !this.state.showpopup
            })

            if (res['data']['status'] === "send_successfully") {
                const bench_status_url = origin.concat("/populate_bench_status")
                const data_for_benchStatus = {
                    bench_id: this.state.data[index]['bench_id'],
                    scenario_group_id: this.state.data[index]['scenario_group_id'],
                    tag_name: this.state.tageNameVersion,
                    remark: this.state.remarks
                }
                //
                // Function to update bench status table
                //
                updateBenchStatusTable(data_for_benchStatus, bench_status_url).then(res => {
                    console.log(res)
                    //console.log("Response after updating bench status = ", res)
                })
            }

        })

    }

    //
    // Function to pull data from bench
    //
    pullFromBenchAPI(right_index) {
        const index = right_index
        console.log("INDEX FOR PULL : ", right_index)
        const data_for_pull = {
            bench_id: this.state.data[index]['bench_id'],
            test_point_id: this.state.data[index]['test_point_id']
        }
        const push_url = (window.location.origin).concat("/pull-reprocessed-output-from-bench")
        pullFromBench(data_for_pull, push_url).then(res => {
            //console.log("response after pulling from bench : ", res)
            if (res['data']['status'] === "pulled_completed") {
                getTestDataBenchMappingInfo().then(res => {
                    this.setState(prevState => {
                        return {
                            ...prevState,
                            data: res.data.map((item, itemIndex) => {
                                if (itemIndex === parseInt(index, 10)) {
                                    return {
                                        test_point_id: item.test_point_id,
                                        bench_id: item.bench_id,
                                        scenario_group_id: item.scenario_group_id,
                                        bench_name: item.bench_name,
                                        scenario_group_name: item.scenario_group_name,
                                        status: item.status,
                                        upload_button: false
                                    }
                                } else {
                                    return item
                                }
                            })
                        }
                    })
                })


            }
            console.log("state after pulling : ", this.state)
            //
            // Function for set state
            //
            this.setState({
                statusPopup: res['data']['status_message'],
                showpopup: !this.state.showpopup,
                test_run_id: res['data']['test_run_id'],
            })

            //const bench_status_url = (window.location.origin).concat("/populate_bench_status")
            //const data_for_benchStatus = {
            //                        bench_id : this.state.data[index]['bench_id'],
            //                       test_run_id : this.state.test_run_id,
            //                   }
            //
            // updateBenchStatusTable(data_for_benchStatus, bench_status_url).then(res =>{
            //     console.log("Response after updating bench status = ", res)
            // })

        })

    }


    //
    // Function to clean the bench
    //
    cleanBenchProcess(e, index_val) {
        e.preventDefault()
        const cleaning_url = (window.location.origin).concat('/clean-bench')
        const index_value = index_val['index']
        console.log("Index : ", index_value)
        console.log("from cleaning : ", this.state.data)
        const param = {
            bench_id: this.state.data[index_value]['bench_id']
        }
        //
        // Function to clean input and output bench
        //
        cleanBenchInputOutput(cleaning_url, param).then(
            res => {
                console.log("response after cleaning : ", res.data.status)
                getTestDataBenchMappingInfo().then(res => {
                    this.setState(prevState => {
                        return {
                            ...prevState,
                            data: res.data.map((item, itemIndex) => {
                                if (itemIndex === parseInt(index_value, 10)) {
                                    return {
                                        test_point_id: item.test_point_id,
                                        bench_id: item.bench_id,
                                        scenario_group_id: item.scenario_group_id,
                                        bench_name: item.bench_name,
                                        scenario_group_name: item.scenario_group_name,
                                        status: item.status,
                                        upload_button: false,

                                    }
                                } else {
                                    return item
                                }
                            })
                        }
                    })
                })
                //
                // Function for set state
                //
                this.setState({
                    showpopup: !this.state.showpopup,
                    statusPopup: res.data['status_message']
                })
            }
        )

    }
    //
    // Function to start the bench
    //
    startBenchFunction(e, index_val) {
        e.preventDefault()
        const index_value = index_val['index']
        const start_bench_url = (window.location.origin).concat('/start')
        const data_to_api = {
            bench_id: this.state.data[index_value]['bench_id'],
            test_point_id: this.state.data[index_value]['test_point_id']
        }
        startBenchProcess(start_bench_url, data_to_api).then(res => {
            console.log("response after start api : ", res)
            this.setState({
                showpopup: !this.state.showpopup,
                statusPopup: res.data['status_message']
            })
            console.log(this.state)
        })
        console.log(data_to_api)
    }
    //
    // Function to start bench
    //
    startBench(e, index_val) {
        e.preventDefault()
        const index_value = index_val['index']

        const run_dummy_bench_url = (window.location.origin).concat('/create_bench_data')
        const data_dummy_app = {
            bench_id: this.state.data[index_value]['bench_id'],
            confidence_percent: 10,
            timestamp_error_percent: 3
        }
        //
        // Function to create bench data
        //
        createBenchData(run_dummy_bench_url, data_dummy_app).then((res) => {
            console.log(res)
            console.log('Now u can pull')
            this.setState({
                showpopup: !this.state.showpopup,
                statusPopup: "Processing Completed"
            })
        })


    }

    //
    // Function to stop bench
    //
    stopBench(e, index_val) {
        e.preventDefault()
        console.log("tag name : ", this.state.tageNameVersion)
        const index_value = index_val['index'];
        const stop_bench_url = (window.location.origin).concat('/stop')
        const data_to_api = {
            bench_id: this.state.data[index_value]['bench_id'],
            test_point_id: this.state.data[index_value]['test_point_id']
        }
        //
        // function to stop bench process
        //
        stopBenchProcess(stop_bench_url, data_to_api).then(res => {
            console.log("response after stop :", res)
            this.setState({
                showpopup: !this.state.showpopup,
                statusPopup: res.data['status_message']
            })
        })
        this.setState(prevState => {
            return {
                data: prevState.data.map((item, itemIndex) => {
                    if (itemIndex === parseInt(index_value, 10)) {
                        return {
                            test_point_id: item.test_point_id,
                            bench_id: item.bench_id,
                            scenario_group_id: item.scenario_group_id,
                            bench_name: item.bench_name,
                            scenario_group_name: item.scenario_group_name,
                            status: item.status,
                            upload_button: false
                        }
                    } else {
                        return item
                    }
                })
            }
        })
    }

    //
    // Function
    // called after component is 
    //mounted
    //
    componentDidMount() {
        //
        // Function to get test data bench mapping information
        //

        getTestDataBenchMappingInfo().then(res => {
            console.log("Calling it.....")
            console.log(res.data)
            if (res.data) {
                this.props.dispatch(addTestTableFromAPI(res.data))
                this.setState(prevState => {
                    return {
                        ...prevState,
                        data: res.data
                    }
                })
            } else {
                this.props.dispatch(addTestTableFromAPI([]))
            }
        })
        console.log("Updated  : ", this.state)

        const bench_url = (window.location.origin).concat('/get_bench_details')
        //
        // Function to get bench details
        //
        getBenchDetails(bench_url).then(res => {
            console.log(res.data['data'])
            this.setState({
                bench_details: res.data['data']
            })
        })

        const group_name_url = (window.location.origin).concat('/get_scenario_group_names')
        getAllScenarioGroupNames(group_name_url).then(response => {
            console.log("Response : ", response)
            console.log(response.data['data'])
            this.setState({
                group_name_list: response.data['data']
            })

        })
    }
    //
    // Function to handle open dialog modal
    //
    handleOpenDialogModal(e, index_val) {
        e.preventDefault()

        const index = index_val['index']
        this.setState((prevState) => {
            return {
                data: prevState.data,
                showpopup: prevState.showpopup,
                statusPopup: prevState.statusPopup,
                toggleButton: prevState.toggleButton,
                showRowActions: index,
                editSelectedRow: prevState.editSelectedRow,
                deleteSelectedRow: prevState.deleteSelectedRow
            }
        })
    }
    //
    // Function to handle close dialog modal
    //
    handleCloseDialogModal() {
        this.setState((prevState) => {
            return {
                data: prevState.data,
                showpopup: prevState.showpopup,
                statusPopup: prevState.statusPopup,
                toggleButton: prevState.toggleButton,
                showRowActions: undefined,
                editSelectedRow: prevState.editSelectedRow,
                deleteSelectedRow: prevState.deleteSelectedRow
            }
        })
    }

    //
    // Function to handle open edit modal
    //
    handleOpenEditModal() {

        this.setState((prevState) => {
            return {
                data: prevState.data,
                showpopup: prevState.showpopup,
                statusPopup: prevState.statusPopup,
                toggleButton: prevState.toggleButton,
                showRowActions: undefined,
                editSelectedRow: prevState.showRowActions,
                deleteSelectedRow: prevState.deleteSelectedRow
            }
        })
    }
    //
    // Function to handle close edit modal
    //
    handleCloseEditModal() {
        this.setState((prevState) => {
            return {
                data: prevState.data,
                showpopup: prevState.showpopup,
                statusPopup: prevState.statusPopup,
                toggleButton: prevState.toggleButton,
                showRowActions: prevState.showRowActions,
                editSelectedRow: undefined,
                deleteSelectedRow: prevState.deleteSelectedRow
            }
        })
    }
    //
    // Function to handle open delete modal
    //
    handleOpenDeleteModal() {
        this.setState((prevState) => {
            return {
                data: prevState.data,
                showpopup: prevState.showpopup,
                statusPopup: prevState.statusPopup,
                toggleButton: prevState.toggleButton,
                deleteSelectedRow: prevState.showRowActions,
                showRowActions: undefined,
                editSelectedRow: prevState.editSelectedRow
            }
        })
    }
    //
    // Function to handle close delete modal
    //
    handleCloseDeleteModal() {
        this.setState((prevState) => {
            return {
                data: prevState.data,
                showpopup: prevState.showpopup,
                statusPopup: prevState.statusPopup,
                toggleButton: prevState.toggleButton,
                showRowActions: prevState.showRowActions,
                editSelectedRow: prevState.showRowActions,
                deleteSelectedRow: undefined
            }
        })
    }
    //
    // Function to handle open test point
    //
    handleOpenTestPoint() {
        this.setState((prevState) => {
            return {
                ...prevState,
                testPoint: true
            }
        })
    }
    //
    // Function to handle close test point
    //
    handleCloseTestPoint() {
        this.setState((prevState) => {
            return {
                testPoint: false
            }
        })
    }
    //
    // Function to submit test point
    //
    handleTestPointSubmit(e) {
        e.preventDefault();
        this.handleCloseTestPoint();
    }

    render() {
        return (
            <div className="container-fluid">
                <Breadcrumb>
                    
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                    <Link to='/welcome'>Welcome</Link>
                        
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=""  >
                    <Link to='open_loop'>Open loop</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="/upload_file" active >
                        Scheduler
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="row">
                    <div className="col mt-5 mx-auto">
                        <div className="card" style={{ backgroundColor: "white" }}>
                            <div className="card-header" style={{ backgroundColor: "#757AF7" }}>
                                <div className="row align-items-center">
                                    <div className="col-md-10">
                                        <h1 style={{ color: "white", fontSize: "100% !important" }}>Scheduler</h1>
                                    </div>
                                    <div className="col-md-2 text-center">
                                        <button
                                            className="btn btn-light"
                                            style={{ color: "#753DFF" }}
                                            onClick={this.handleOpenTestPoint}
                                        >
                                            Add Test Point
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {this.state.data.length > 0 ? <table className="table">
                                    <thead className="table-head">
                                        <tr>
                                            <th scope="col" key="Test Point Id" style={{ textAlign: "center" }}>Test Id</th>
                                            <th scope="col" key="Scenario Group Name" style={{ textAlign: "center" }}>Scenario Group Name</th>
                                            <th scope="col" key="Bench Id" style={{ textAlign: "center" }}>Bench Name</th>
                                            <th scope="col" key="Status" style={{ textAlign: "center" }}>Status</th>
                                            <th scope="col" key="action" style={{ textAlign: "center" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.map((element, index) => {
                                            return (<tr key={index} className="table-row">
                                                <td style={{ color: "#464646" }}>{element.test_point_id}</td>
                                                <td style={{ color: "#464646" }}>{element.scenario_group_name}</td>
                                                <td style={{ color: "#464646" }}>{`${element.bench_name} (${element.bench_id})`}</td>
                                                {element.status === "NULL" || element.status === "completed_with_success" || element.status === "completed_with_error" ?
                                                    <td style={{ color: "#464646" }}></td> :
                                                    <td style={{ color: "#464646" }}>{element.status}</td>
                                                }
                                                <td>
                                                    <button
                                                        disabled={(this.state.data[index].status === "completed_with_success" | this.state.data[index].status === "data_dispatched" | this.state.data[index].status === "completed_with_error" | this.state.data[index].status === "pull_completed_success" | this.state.data[index].status === "NULL") ? false : true}
                                                        className="btn"
                                                        id={index}
                                                        value={index}
                                                        onClick={(e) => { this.toggleTagName(e) }}
                                                        style={{ marginRight: "1%" }}
                                                        data-toggle="tooltip" data-placement="top" title={this.state.data[index].status === "data_dispatched" ? "Pull" : "Push"}
                                                    >
                                                        {this.state.data[index].status === "data_dispatched" ? "Pull" : "Push"}
                                                    </button>
                                                    <button
                                                        className="btn"
                                                        style={{ marginRight: "1%" }}
                                                        value={index} onClick={(e) => { this.startBenchFunction(e, { index }) }}
                                                        data-toggle="tooltip" data-placement="top" title="Start Bench"
                                                    >
                                                        <i className="fas fa-play-circle"></i>
                                                    </button>
                                                    <button
                                                        className="btn"
                                                        style={{ marginRight: "1%" }}
                                                        value={index}
                                                        onClick={(e) => this.stopBench(e, { index })}
                                                        data-toggle="tooltip" data-placement="top" title="Stop Bench"
                                                    >
                                                        <i className="fas fa-stop-circle"></i>
                                                    </button>

                                                    <button
                                                        className="btn"
                                                        style={{ marginRight: "1%", marginLeft: "1%" }}
                                                        value={index}
                                                        onClick={(e) => this.cleanBenchProcess(e, { index })}
                                                        data-toggle="tooltip" data-placement="top" title="Reset App"
                                                    >
                                                        <i className="fa fa-undo"></i>
                                                    </button>
                                                    <button
                                                        className="btn"
                                                        id={index}
                                                        style={{ marginRight: "0%" }}
                                                        onClick={(e) => this.handleOpenDialogModal(e, { index })}
                                                        data-toggle="tooltip" data-placement="top" title="Delete"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>)
                                        })}
                                    </tbody>
                                </table>
                                    : <div className="alert alert-secondary" role="alert">
                                        No data available
                                    </div>}

                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showpopup ? <PopupModal text={this.state.statusPopup} closePopup={this.togglePopup.bind(this)} /> : ""}
                {this.state.tagName ? <TagNamePopUpModal tagnamechange={this.handleTagNameVersionChange.bind(this)}
                    remarkschange={this.handleRemarksChange.bind(this)} sendToBenchAPI={this.sendToBenchAPI.bind(this)}
                    closeTagModal={this.closeTagNameModal.bind(this)} /> : ""}

                {this.state.showRowActions !== undefined && this.state.showRowActions >= 0 ?
                    <Modal isOpen={this.state.showRowActions >= 0}>
                        <ModalHeader
                            toggle={this.handleCloseDialogModal}
                            style={{ color: "#753DFF" }}
                        >
                            Choose Actions
                        </ModalHeader>
                        <ModalBody>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <Button className="btn" style={{ width: "100%" }} onClick={this.handleOpenEditModal}>Edit</Button>
                                        </div>
                                        <div className="col-sm-6">
                                            <Button className="btn" style={{ width: "100%" }} onClick={this.handleOpenDeleteModal}>Delete</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button className="btn btn-secondary" onClick={this.handleCloseDialogModal}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                    : undefined}

                {this.state.editSelectedRow >= 0 ?
                    <EditTestTableModal
                        formData={this.state.data[parseInt(this.state.editSelectedRow)]}
                        editSelectedRow={this.state.editSelectedRow}
                        handleCloseEditModal={this.handleCloseEditModal}
                    />
                    : undefined}
                {this.state.deleteSelectedRow >= 0 ?
                    <DeleteTestTableModal
                        deleteSelectedRow={this.state.deleteSelectedRow}
                        handleCloseDeleteModal={this.handleCloseDeleteModal}
                        useHistory={this.props}
                        deleteContent={this.state.data[parseInt(this.state.deleteSelectedRow)]}
                    />
                    : undefined}
                {this.state.testPoint
                    ? <Modal isOpen={true}>
                        <ModalHeader
                            toggle={this.handleCloseTestPoint}
                            style={{ backgroundColor: "#753DFF", color: "white" }}
                        >
                            Add Test Point
                        </ModalHeader>
                        <ModalBody>
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={this.handleTestPointSubmit}>
                                        <div className="form-group">
                                            <label htmlFor="scenarioGroupName">Scenario Group Name</label>
                                            <select className="form-control" id="scenarioGroupName" value={this.state.scenario_group_name} onChange={(e) => this.onhandleChangeGroupName(e)}>
                                                <option>Select!!!!</option>
                                                {this.state.group_name_list.map((key, i) => {
                                                    return (
                                                        <option value={key} key={i}>{key}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="benchName">Bench Name</label>
                                            <select className="form-control" id="benchName" value={this.state.selected_bench_name} onChange={(e) => this.onhandleChangeBenchName(e)}>
                                                <option>Select</option>
                                                {this.state.bench_details.map((index, i) => {
                                                    return (
                                                        <option value={index['bench_name']} key={i}>{index['bench_name']}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <button className="btn" type="submit" onClick={(e) => this.handleAdd(e)}>Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button className="btn btn-secondary" onClick={this.handleCloseTestPoint}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                    : undefined}

            </div>
        )
    }
}
UploadFile.propTypes = {
    history: PropTypes.string,
    dispatch: PropTypes.string,
}
UploadFile.defaultProps = {
    history: [],
    dispatch: [],
}

const mapStateToProps = (state) => {
    return {
        testData: state.scenarioTestData.testData
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default connect(mapStateToProps)(UploadFile)
